import { Component } from "../component"
import { scrollLoop } from "../helpers/scroll-loop"
import anime from "animejs"
import { iterable } from "../helpers/iterable"

export class SectionCollectionNavigation extends Component {
  constructor(props) {
    super(props)

    this.dynamicClasses = {
      sticky: "-sticky",
      active: "-active",
    }
  }

  ui() {
    return {
      links: ".section-collection-navigation-link",
    }
  }

  handleScroll(position) {
    const { links } = this.$ui
    const { sticky, active } = this.dynamicClasses
    const height = 42
    const headerHeight = 50
    const sections = [this.sectionAbout, this.sectionProducts]
    sections.sort((a, b) => a.offsetTop - b.offsetTop)

    const stickyBreakpoint = sections[0].offsetTop - height - headerHeight
    const navigationBreakpoint = sections[1].offsetTop - window.innerHeight / 2
    const isSticky = position >= stickyBreakpoint

    if (window.innerWidth >= 768) {
      if (isSticky && !this.$el.parentElement.classList.contains(sticky)) {
        this.$el.parentElement.classList.add(sticky)
      } else if (
        !isSticky &&
        this.$el.parentElement.classList.contains(sticky)
      ) {
        this.$el.parentElement.classList.remove(sticky)
      }
    }

    links.forEach((link, index) => {
      const isActive =
        index === 0
          ? position < navigationBreakpoint
          : position >= navigationBreakpoint
      link.classList.toggle(active, isActive)
    })
  }

  attachEvents() {
    const { links } = this.$ui
    const sections = [this.sectionAbout, this.sectionProducts]
    const height = 42
    const headerHeight = 50

    sections.sort((a, b) => a.offsetTop - b.offsetTop)

    iterable(links).forEach((link, index) => {
      let offset = 0

      if (index === 1) {
        offset = window.innerWidth >= 768 ? 65 : 55
      }

      link.addEventListener("click", (e) => {
        e.preventDefault()

        const position =
          sections[index].offsetTop - height - headerHeight - offset
        anime({
          targets: [document.documentElement, document.body],
          scrollTop: position,
          duration: 900,
          easing: "easeInOutQuart",
        })
      })
    })
  }

  nameLinks() {
    const { links } = this.$ui
    const sectionAboutTitle = this.sectionAbout.querySelector(
      ".section-editor-title"
    )
    const sectionProductsTitle = this.sectionProducts.querySelector(
      ".collection-products-title"
    )

    const titles = [sectionAboutTitle, sectionProductsTitle]

    titles.sort((a, b) => a.offsetTop - b.offsetTop)

    iterable(links).forEach((link, index) => {
      link.textContent = titles[index].textContent
    })

    if (sectionAboutTitle.offsetTop > sectionProductsTitle.offsetTop) {
      document.querySelector(".section-editor-background").style.marginBottom =
        "0"
    }
  }

  created() {
    this.sectionAbout = document.querySelector(".section-editor")
    this.sectionProducts = document.querySelector(".collection-products")
    this.sectionAboutTop = this.sectionAbout.offsetTop

    this.nameLinks()
    this.attachEvents()

    scrollLoop(() => {
      this.handleScroll(window.pageYOffset)
    })
  }
}
